export const dataItems = [
    {
        id: 1,
        image: 'jade-face-roller',
        title: 'JADE FACE ROLLER',
        price: 330,
        category: 'FACE MASSAGE',
        tags: ['Jade', 'Relax', 'Spa'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 2,
        image: 'swedish-massage',
        title: 'SWEDISH MASSAGE',
        price: 320,
        category: 'BODY RELAX',
        tags: ['Relax', 'Spa', 'Treatment'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 3,
        image: 'body-brushing',
        title: 'BODY BRUSHING',
        price: 340,
        category: 'BODY RELAX',
        tags: ['Hotel', 'Spa'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 4,
        image: 'relaxing-sauna',
        title: 'RELAXING SAUNA',
        price: 300,
        category: 'SAUNA',
        tags: ['Relax', 'Hotel', 'Sauna'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 5,
        image: 'brown-sugar-scrub',
        title: 'BROWN SUGAR SCRUB',
        price: 290,
        category: 'SPA',
        tags: ['Relax', 'Spa', 'Treatment'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 6,
        image: 'salt-body-scrub',
        title: 'SALT BODY SCRUB',
        price: 360,
        category: 'SPA',
        tags: ['Spa', 'Treatment'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 7,
        image: 'lifting-serum',
        title: 'LIFTING SERUM',
        price: 370,
        category: 'BODY RELAX',
        tags: ['Bath', 'Lifting'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 8,
        image: 'powder',
        title: 'POWDER',
        price: 360,
        category: 'BODY RELAX',
        tags: ['Bath', 'Roller', 'Serum'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 9,
        image: 'oil-peeling',
        title: 'OIL PEELING',
        price: 240,
        category: 'TREATMENT',
        tags: ['Aromatherapy', 'Bath', 'Natural'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 10,
        image: 'exfoliation',
        title: 'EXFOLIATION',
        price: 260,
        category: 'TREATMENT',
        tags: ['Aromatherapy', 'Bath', 'Natural'],
        quantity: 1,
        subtotal: 0
    },
    {
        id: 11,
        image: 'caviar-lift',
        title: 'CAVIAR LIFT',
        price: 390,
        category: 'FACE MASSAGE',
        tags: ['Roller', 'Serum'],
        quantity: 1,
        subtotal: 0
    }
]